import React from "react";
import { css } from "@emotion/react";
export const vville = "Marseille";
const rville = "in Marseille";
const rdepartement = "in Bouches du Rhône";
const rregion = "in Provence-Alpes-Côte d'Azur";
export const url = "https://architectes-interieur-marseille.com";
const renviron =
  "Our interior design services are carried out in Marseille in the neighboring towns of Marseille, including Cassis, Aubagne, La Ciotat, Sausset-les-Pins, Allauch, Carry-le-Rouet, Carnoux-en-Provence, Les Pennes-Mirabeau, etc.<br />We also operate in other towns in Bouches-du-Rhône (13): Le Tholonet, Cabriès, Trets, Saint-Cannat, Puyricard, Eguilles, Martigues, Arles (non-exhaustive list), but also in the Vaucluse department (84).";

export function variablesSubstitution(string) {
  return string
    .replace(/rville/g, rville)
    .replace(/vville/g, vville)
    .replace(/rdepartement/g, rdepartement)
    .replace(/rregion/g, rregion)
    .replace(/renviron/g, renviron);
}
export class VilleLogo extends React.Component {
  render() {
    return (
      <div
        css={css`
          text-align: right;
          margin-right: 2px;
          font-size: 14px;
          line-height: 10px;
          bottom: 4px;
          right: 0;
          @media (max-width: 800px) {
            font-size: 12px;
            bottom: 6px;
          }
          @media (max-width: 600px) {
            font-size: 12px;
            bottom: 9px;
          }
        `}
      >
        Marseille
      </div>
    );
  }
}

export class Ville extends React.Component {
  render() {
    return <span>Marseille</span>;
  }
}

export class Rville extends React.Component {
  render() {
    return <span>in Marseille</span>;
  }
}

export class Rdepartement extends React.Component {
  render() {
    return <span>in Bouches du Rhône</span>;
  }
}

export class Rregion extends React.Component {
  render() {
    return <span>in Provence-Alpes-Côte d'Azur</span>;
  }
}

export const slider_ai_paris =
  "Renovation of a Haussmann apartment in Paris by an interior designer";
export const slider_di_paris =
  "Furnishing of a Haussmann-style apartment by an interior designer in Paris";
export const slider_a_paris =
  "Extension of an old house created by an architect in Ile-de-France";
export const slider_ac_paris =
  "Design of a restaurant by an architect specializing in commercial architecture in the Paris region";
export const slider_jp_paris =
  "Landscaping of the terrace of an apartment in Paris";

export const slider_mobile_ai_paris =
  "Design of a Haussmann apartment by an interior designer based in Paris";
export const slider_mobile_di_paris =
  "Interior decoration of a typical Parisian apartment";
export const slider_mobile_a_paris =
  "Extension of a house in Meulière carried out by an architect";
export const slider_mobile_ac_paris =
  "An architect designs a restaurant in Paris";
export const slider_mobile_jp_paris =
  "Terrace designed by a landscape gardener in Paris";

export const slider_ai_annecy =
  "Renovation of an old apartment in Annecy by an interior designer";
export const slider_di_annecy =
  "Interior decoration of a single-storey house in the suburbs of Geneva";
export const slider_a_annecy =
  "Contemporary house made of wood and concrete by an architect in Haute-Savoie (74)";
export const slider_ac_annecy = "Commercial architecture in Aix-les-Bains";
export const slider_jp_annecy =
  "Garden with swimming pool designed by a landscape architect in Annecy";

export const slider_mobile_ai_annecy =
  "Contemporary open kitchen designed by an interior designer in Annecy";
export const slider_mobile_di_annecy =
  "Interior design of an apartment in Geneva";
export const slider_mobile_a_annecy =
  "Contemporary house designed by an architect on the Swiss border";
export const slider_mobile_ac_annecy =
  "Interior design of a restaurant in the historic center of Annecy";
export const slider_mobile_jp_annecy =
  "Terrace designed by a landscaper in Haute-Savoie (74)";

export const slider_ai_aix =
  "Complete renovation of a typical Aix-en-Provence apartment by an interior designer";
export const slider_di_aix =
  "Renovation of an old apartment in Aix-en-Provence by an interior designer";
export const slider_a_aix =
  "Renovation of a Provencal farmhouse with swimming pool by an architect from Aix-en-Provence";
export const slider_ac_aix =
  "Design of a restaurant by an architect in Aix-en-Provence";
export const slider_jp_aix =
  "Landscaping of the terrace of a farmhouse in the Luberon";

export const slider_mobile_ai_aix =
  "Design of a contemporary villa in Aix-en-Provence by an interior designer";
export const slider_mobile_by_aix =
  "Interior decoration of an apartment in Aix-en-Provence";
export const slider_mobile_a_aix =
  "Construction of a contemporary villa in Provence by an architect";
export const slider_mobile_ac_aix =
  "Design of a restaurant in Aix-en-Provence by an architect";
export const slider_mobile_jp_aix =
  "Landscaping of a Provencal garden by a landscape architect";

export const slider_ai_biarritz =
  "Interior design of a modern villa near Biarritz";
export const slider_di_biarritz =
  "Complete renovation of an art deco apartment in Biarritz";
export const slider_a_biarritz =
  "Construction of an architect-designed house in the Basque Country";
export const slider_ac_biarritz =
  "Design of a restaurant in Biarritz by an architect";
export const slider_jp_biarritz =
  "Landscaping of the garden of a typical Basque house by a landscaper";

export const slider_mobile_ai_biarritz =
  "Interior renovation of an apartment in Biarritz by an interior designer";
export const slider_mobile_by_biarritz =
  "Interior decoration of a contemporary apartment in Biarritz";
export const slider_mobile_a_biarritz =
  "Extension of a stone house created by an architect from the Basque Country";
export const slider_mobile_ac_biarritz =
  "Design of a gourmet restaurant by an architect specializing in commercial architecture";
export const slider_mobile_jp_biarritz =
  "Garden of a modern Basque house landscaped by a landscaper in Biarritz";

export const slider_ai_bordeaux =
  "An interior designer completely renovates a house in Bordeaux";
export const slider_di_bordeaux =
  "Renovation of an apartment in an old building in Bordeaux";
export const slider_a_bordeaux =
  "Construction of an architect-designed house in Gironde";
export const slider_ac_bordeaux =
  "Interior design of a restaurant by an architect in Bordeaux";
export const slider_jp_bordeaux =
  "Landscaping of the garden of a villa in the Bordeaux metropolitan area";

export const slider_mobile_ai_bordeaux =
  "Design of a contemporary house by an interior designer in Bordeaux";
export const slider_mobile_di_bordeaux =
  "Interior renovation of an old apartment in Bordeaux";
export const slider_mobile_a_bordeaux =
  "Contemporary wood and concrete house designed by an architect in Bordeaux";
export const slider_mobile_ac_bordeaux =
  "Renovation of a restaurant by an interior designer in Bordeaux";
export const slider_mobile_jp_bordeaux =
  "Garden of a house in the Bordeaux region designed by a landscape architect";

export const slider_ai_brussels =
  "Design of a loft-style apartment by an interior designer in Brussels";
export const slider_di_brussels =
  "Interior renovation of an old house in Brussels";
export const slider_a_brussels =
  "Renovation of a villa by an architect in the Brussels-Capital region";
export const slider_ac_bruxelles =
  "Bistronomic restaurant in Brussels designed by an interior designer";
export const slider_jp_brussels =
  "Terrace of a Brussels apartment designed by a landscape architect";

export const slider_mobile_ai_brussels =
  "Renovation of a contemporary house by an interior designer in the Brussels-Capital region";
export const slider_mobile_di_brussels =
  "An interior designer decorates an apartment in Brussels";
export const slider_mobile_a_bruxelles =
  "Renovation of a Brussels house by an architect";
export const slider_mobile_ac_bruxelles =
  "Commercial layout of a restaurant by an interior designer";
export const slider_mobile_jp_bruxelles =
  "Garden of a town house in Brussels landscaped by a landscaper";

export const slider_ai_lille =
  "Interior renovation of an old house in the Lille metropolis";
export const slider_di_lille =
  "Renovation and interior decoration of a 1930s house near Lille";
export const slider_a_lille =
  "Extension of a brick house made by an architect in the Lille region";
export const slider_ac_lille =
  "Bar designed by an architect specializing in commercial architecture in Lille";
export const slider_jp_lille =
  "Small terrace of an apartment in the Lille region designed by a landscaper";

export const slider_mobile_ai_lille =
  "Renovation of a 1930s house by an interior designer in Lille";
export const slider_mobile_di_lille =
  "An interior designer completely renovates an apartment in old Lille";
export const slider_mobile_a_lille =
  "Extension of an old house in the Lille region";
export const slider_mobile_ac_lille =
  "Bistronomic restaurant in Lille designed by an architect";
export const slider_mobile_jp_lille =
  "Garden of a town house designed by a landscaper from the Lille region";

export const slider_ai_lyon =
  "Renovation of an apartment in Lyon by an interior designer";
export const slider_by_lyon =
  "An interior designer decorates an apartment in Lyon";
export const slider_a_lyon =
  "Extension of an old house in the Lyon region by an architect";
export const slider_ac_lyon = "Restaurant in Lyon designed by an architect";
export const slider_jp_lyon =
  "Terrace of an apartment in Lyon designed by a landscape architect";

export const slider_mobile_ai_lyon =
  "Old apartment in Lyon renovated by an interior designer";
export const slider_mobile_by_lyon =
  "Renovation of a Canut apartment in Lyon by an interior designer";
export const slider_mobile_a_lyon =
  "Construction of an architect-designed house in Lyon";
export const slider_mobile_ac_lyon =
  "An architect specializing in commercial architecture renovates a restaurant in Lyon";
export const slider_mobile_jp_lyon =
  "Terrace of an apartment located in a 1970s building fitted out by a landscaper";

export const slider_ai_marseille =
  "Open kitchen in a villa designed by an interior designer in Marseille";
export const slider_di_marseille =
  "Living room of an old house in Marseille renovated by an interior designer";
export const slider_a_marseille =
  "Extension of a house designed by an architect from the Marseille region";
export const slider_ac_marseille =
  "Bistronomic restaurant designed by a specialist in commercial architecture in Marseille";
export const slider_jp_marseille =
  "Mediterranean garden designed by a landscape gardener";

export const slider_mobile_ai_marseille =
  "Kitchen designed by an interior designer in Marseille";
export const slider_mobile_di_marseille =
  "Interior decoration of an old apartment in Marseille";
export const slider_mobile_a_marseille =
  "Contemporary house with swimming pool in Bouches-du-Rhône";
export const slider_mobile_ac_marseille =
  "Restaurant after renovation work by an interior designer";
export const slider_mobile_jp_marseille =
  "A landscape architect designs a Mediterranean garden in the Marseille region";

export const slider_ai_montpellier =
  "Renovation of an apartment from the 70s in Montpellier by an interior designer";
export const slider_di_montpellier =
  "Furnishing of an old apartment with open kitchen by an interior decorator";
export const slider_a_montpellier =
  "Construction of a contemporary villa in the Montpellier area by an architect";
export const slider_ac_montpellier =
  "Development of commercial premises by an architect in Montpellier";
export const slider_jp_montpellier =
  "Southern terrace designed by a landscape architect in Montpellier";

export const slider_mobile_ai_montpellier =
  "Renovation of the kitchen of an old apartment by an interior designer in Montpellier";
export const slider_mobile_di_montpellier =
  "Interior decoration of a contemporary villa in Hérault by interior designer";
export const slider_mobile_a_montpellier =
  "Architectural wood and concrete house by an architect from the Montpellier region";
export const slider_mobile_ac_montpellier =
  "Restaurant designed and decorated by an architect specializing in commercial architecture";
export const slider_mobile_jp_montpellier =
  "Wooden terrace designed by a landscape gardener in Montpellier";

export const slider_ai_nantes =
  "Living room with open kitchen designed by an interior designer in Nantes";
export const previous_slider =
  "Interior decoration of an old apartment in Nantes";
export const slider_a_nantes =
  "Modern extension of an old house in Nantes carried out by an architect";
export const slider_ac_nantes =
  "Restaurant designed by an architect in Loire-Atlantique (44)";
export const slider_jp_nantes =
  "Landscaping of an architect-designed house by a landscaper based in the Nantes metropolitan area";

export const slider_mobile_ai_nantes =
  "Modern living room in an apartment designed by an interior designer in Nantes";
export const previous_mobile_slider =
  "Living room of an old apartment decorated by a Nantes interior designer";
export const slider_mobile_a_nantes =
  "Design of an architect's wooden house in Loire-Atlantique (44)";
export const slider_mobile_ac_nantes =
  "An architect designs a bistronomic restaurant in Nantes";
export const slider_mobile_jp_nantes =
  "Landscaped terrace of a town house in Nantes designed by a landscape architect";

export const slider_ai_names =
  "Kitchen opening onto a terrace designed by an interior designer in Nîmes";
export const slider_di_nimes =
  "Interior decoration of an old apartment in Nîmes";
export const slider_a_nimes =
  "Renovation of an old house in Vaucluse by an architect";
export const slider_ac_nimes =
  "Restaurant renovated by an architect specializing in commercial architecture in Gard (30)";
export const slider_jp_nimes =
  "Terrace of an old stone house designed by a landscaper from the Nîmes region";

export const slider_mobile_ai_names =
  "Design of a duplex living room by an interior designer in Nîmes";
export const slider_mobile_di_nimes =
  "An interior designer decorates the living room of an old apartment in Nîmes";
export const slider_mobile_a_nimes =
  "Construction of a contemporary villa by an architect in Gard";
export const slider_mobile_ac_nimes =
  "Complete renovation of a restaurant by a Nîmes architect";
export const slider_mobile_jp_nimes =
  "Provençal garden designed by a landscape architect in Vaucluse";

export const slider_ai_quimper =
  "Complete renovation of a Breton house by an interior designer in Quimper";
export const slider_di_quimper =
  "Interior decoration of a fisherman's house in Brittany";
export const slider_a_quimper =
  "Extension of an old Breton house by an architect based in Quimper";
export const slider_ac_quimper =
  "Restaurant on the Breton coast designed by an architect";
export const slider_jp_quimper =
  "Landscaping of the garden of a house in Brittany by a landscaper";

export const slider_mobile_ai_quimper =
  "Kitchen designed by an interior designer in Brittany";
export const slider_mobile_di_quimper =
  "Renovation of the living room of a house in Quimper";
export const slider_mobile_a_quimper =
  "Extension of a Breton house created by an architect";
export const slider_mobile_ac_quimper =
  "Restaurant completely renovated by an architect specializing in commercial architecture";
export const slider_mobile_jp_quimper =
  "Landscaping in Brittany carried out by a landscape architect";

export const slider_ai_toulon =
  "Renovation of a kitchen by an interior designer in the Var";
export const toulon_slider =
  "Interior decoration of a villa on the French Riviera";
export const slider_a_toulon =
  "Contemporary villa designed by an architect based in Toulon";
export const slider_ac_toulon =
  "Côte d'Azur restaurant designed by an architect";
export const slider_jp_toulon =
  "Mediterranean garden with swimming pool designed by a landscape gardener";

export const slider_mobile_ai_toulon =
  "Interior design of a villa on the Côte d'Azur by an interior designer";
export const slider_mobile_di_toulon =
  "An interior designer renovates an old apartment in Toulon";
export const slider_mobile_a_toulon = "Architect's house on the Côte d'Azur";
export const slider_mobile_ac_toulon =
  "Renovation of a restaurant by an architect specializing in commercial and tertiary architecture in Var 83";
export const slider_mobile_jp_toulon =
  "A landscape architect designs a Mediterranean garden with a swimming pool on the Côte d'Azur";

export const slider_ai_toulouse =
  "Renovation of an apartment in Toulouse city center by an interior designer";
export const slider_by_toulouse =
  "Interior decoration of the living room of an apartment in Toulouse";
export const slider_a_toulouse =
  "Contemporary eco-responsible villa designed by an architect in Toulouse";
export const slider_ac_toulouse =
  "Interior design of a restaurant by an interior designer";
export const slider_jp_toulouse =
  "A landscaper designs the terrace of a contemporary apartment in Toulouse";

export const slider_mobile_ai_toulouse =
  "Design of an American kitchen by an interior designer in Toulouse";
export const slider_mobile_di_toulouse =
  "An interior designer renovates the living room of an old apartment in Toulouse";
export const slider_mobile_a_toulouse =
  "Construction of the extension of an old house in Toulouse";
export const slider_mobile_ac_toulouse =
  "Renovation of a bar - restaurant in Toulouse by an architect";
export const slider_mobile_jp_toulouse =
  "Terrace designed by a landscape architect in Toulouse";

export const slider_ai_tours =
  "Renovation of a barn by an interior designer in Touraine";
export const slider_di_tours =
  "Decoration of a living room by a professional decorator working in Tours";
export const slider_a_tours =
  "Complete renovation of a farmhouse by an architect in Touraine";
export const slider_ac_tours =
  "Design of a bar in Tours by an interior designer";
export const slider_jp_tours =
  "Garden with swimming pool and terrace designed by a landscaper near Tours";

export const slider_mobile_ai_tours =
  "Design of a contemporary house by an interior designer in Tours";
export const slider_mobile_di_tours =
  "Interior decoration of an apartment in the city center of Tours";
export const slider_mobile_a_tours =
  "Complete renovation of a barn in Touraine by an architect";
export const slider_mobile_ac_tours =
  "An architect specializing in commercial architecture is designing a restaurant/bar in Indre-et-Loire 37";
export const slider_mobile_jp_tours =
  "Terrace of a farmhouse landscaped by a landscaper in Touraine";
